import $ from 'jquery'

export default class PictureUploader {

  constructor(selector) {
    this.$input = $(selector)
    this.$is_multiple = $(selector).is('[multiple]')
    this.$label = this.$input.next('label')
    this.$labelVal = this.$label.html()
    this.$selectedFiles = this.$input.parent().find('.selected-files')
    this.$error = $(this.$input.data('error-target'))
    this.maxNb = this.$input.data('max-nb')
    this.maxSize = this.$input.data('max-size')
    //this.format = this.$input.data('format')
    this.format = null;
    this._translation = {};
    this.init()

  }

  init() {
    if(this.$is_multiple) {
      this.$input.on('change', () => this.on_change_multiple())
    } else {
      this.$input.on('change', () => this.on_change())      
    }
    this.$input.on('focus', () => this.on_focus())
    this.$input.on('blur', () => this.on_blur())
  }

  seti18n(data) {
    for (var key in data) {
        this._translation[key] = data[key]
    }
  }

  on_change() {
    var fileName = ''
    var val = this.$input.val()

    this.hideErrorMsg()

    if(val){

        let valid = this.validate()
        if (!valid) {
          this.showErrorMsg()
          this.$input.val('');
          return
        }

        // ex : me_on_the_beach.jpg
        fileName = val.split('\\').pop()
        if(fileName.length > 16) {
            // ex: me_on_the_...jpg
            fileName = fileName.substr(0, 10) + '...' + val.split('.').pop(); 
        }
     }
    if(fileName)
        this.$label.html(fileName);
    else
        this.$label.html(labelVal);
  }

  on_change_multiple() {
    var fileName = ''
    var files = this.$input[0].files

    this.hideErrorMsg()

    if(files.length >= 1){

        let valid = this.validate_multiple()
        if (!valid) {
          this.showErrorMsg()
          this.$input.val('');
          return
        }

        for (var i = 0; i < files.length; i++) {
          if (i != 0) {
            fileName = fileName + ', '
          }
          fileName = fileName + files[i].name;
        }

     }

     this.$selectedFiles.html(fileName);

  }

  on_focus() {
    this.$input.addClass('has-focus')
  }

  on_blur() {
    this.$input.removeClass('has-focus')
  }
  
  hideErrorMsg() {
    this.$error.html('')
    this.$error.hide()
  }

  showErrorMsg() {
    this.$error.html(this.errorMsg)
    this.$error.show()
  }

  validate() {
    let valid = true
    var file = this.$input[0].files[0]

    if(this.maxSize) {
      valid = this.validate_size(file)
      if (!valid) {
        this.errorMsg = this._translation['max_size']
        return false
      }
    }
    if(this.format) {
      valid = this.validate_format(file)
      if (!valid) {
        this.errorMsg = this._translation[this.format]
        return false
      }
    }
    return true
  }

  validate_multiple() {
    let valid = true
    var files = this.$input[0].files

    if(this.maxNb) {
      valid = this.validate_nb(files)
      if (!valid) {
        this.errorMsg = this._translation['max_nb']
        return false
      }
    }

    for (var i = 0; i < files.length; i++) {
      if(this.maxSize) {
        valid = this.validate_size(files[i])
        if (!valid) {
          this.errorMsg = this._translation['max_size_plural']
          return false
        }
      }
      if(this.format) {
        valid = this.validate_format(files[i])
        if (!valid) {
          this.errorMsg = this._translation[this.format + '_plural']
          return false
        }
      }
    }
    return true
  }

  validate_nb(files) {
    if(files.length > this.maxNb) {
      return false
    }
    return true
  }

  validate_size(file) {
      if(file.size > this.maxSize) {
        return false
      }
      return true
  }

  validate_format(file) {
      var url = URL.createObjectURL(file);
      var img = new Image;

      img.onload = function() {

          if(this.format == 'landscape') {
            if(img.height*1.50 < img.width) {
              return false
            }
            return true
          } else {
            if(img.width*1.25 < img.height) {
              return false
            }
            return true
          }

      };

      img.src = url;
  }

}



// WEBPACK FOOTER //
// ./utils/static/utils/js/picture-uploader.js